import { Button, Card } from "react-bootstrap";
import { AlertCard, AlertReferenceTableEnum } from "../types";
import { truncateText } from "../../../utils/textUtils";
import { convertUnixToFormateDate, convertIntUnixToFormateDate } from "../../../utils/dateUtils";
import { COLOR } from "../../../config/constraits";
import { MdLocalPhone } from "react-icons/md";
import { useTranslation } from "react-i18next";

interface DraggableCardProps {
  isDragging: boolean;
  alertCard: AlertCard;
  onSurveyClick: (surveyId: number) => void;
  onClaimClick: (claimId: number) => void;
}

export default function DraggableCard({ alertCard, onSurveyClick, onClaimClick }: DraggableCardProps) {

    const { t } = useTranslation('alert');

    const getOpinionOriginName = (referenceTable: AlertReferenceTableEnum) => {
        if (referenceTable === AlertReferenceTableEnum.SURVEY_IMPORT_RESULT) {
            return t("alert:card.cardShowDetailSurveyOpinionOriginSurvey");
        } else if (referenceTable === AlertReferenceTableEnum.CLAIM) {
            return t("alert:card.cardShowDetailSurveyOpinionOriginClaim");
        }
    }

  return (
    <Card
      text={'dark'}
      style={{
        border: "none",
          borderLeft: '6px solid #004367',
        backgroundColor: alertCard.status == 4 ? COLOR.VERD_LIGHT : "white",
        position: 'relative',
      }}
    >
      <Card.Body style={{ paddingLeft: '10px' }}>
              <Card.Text className="" style={{ fontSize: '14px' }}>
                  {(alertCard.referenceTable === AlertReferenceTableEnum.SURVEY_IMPORT_RESULT) && (
                      <>
                          <a
                              onClick={() => onSurveyClick(alertCard.referenceId)}
                              style={{ textDecoration: 'none', cursor: 'pointer' }}
                              onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                              onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
                          >
                              <b>{getOpinionOriginName(alertCard.referenceTable)}-{alertCard.referenceId} </b>{truncateText(alertCard.comment, 86)}<br />
                          </a>
                          <b>{t("alert:card.cardShowDetailSurveyNps")}: </b>{alertCard.nps} <br /> 
                          <b>{t("alert:card.cardShowDetailSurveyAnswerDate")}: </b>{convertUnixToFormateDate(alertCard.answerDate)} <br />
                      </>
                  )}
                  {(alertCard.referenceTable === AlertReferenceTableEnum.CLAIM ) && (
                      <>
                          <a
                              onClick={() => onClaimClick(alertCard.referenceId)}
                              style={{ textDecoration: 'none', cursor: 'pointer' }}
                              onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                              onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
                          >
                              <b>{getOpinionOriginName(alertCard.referenceTable)}-{alertCard.referenceId} </b>{truncateText(alertCard.comment, 86)}<br />
                          </a>
                          <b>{t("alert:card.cardShowDetailSurveyEntryDate")}: </b>{convertIntUnixToFormateDate(alertCard.entryDate)} <br />
                      </>
                  )}
                  <b>{t("alert:card.cardShowDetailSurveyAlert")}: </b>{alertCard.alertAI} <br />
                  <b>{t("alert:card.cardShowDetailSurveyUser")} </b>{alertCard.userName} <br />
              </Card.Text>
      </Card.Body>
          <Button className="btn-gris"
        style={{position: 'absolute',top: 0, right: 0, padding: '8px 10px',border: 'none',margin: '2px',}}>
              <MdLocalPhone style={{ fontSize: '18px', color: 'grey' }} />
          </Button>
          {/*<div style={{ position: 'absolute', top: '8px', right: '10px' }}><MdLocalPhone style={{ fontSize: '18px', color: 'grey' }} /></div> */}

    </Card>
  );
}